import { useState } from 'react';

const faqItems = [
  {
    q: '51今日吃瓜是什么网站？',
    a: '51今日吃瓜是国内领先的吃瓜内容聚合平台，汇集全网最新最热的吃瓜短视频、直播回放和吃瓜大赛精选内容，覆盖娱乐圈、网红圈、社会热点等多领域，让你一站式吃到最新鲜的瓜。',
  },
  {
    q: '网站上的视频可以免费观看吗？',
    a: '所有吃瓜视频合集均可免费在线观看，无需注册或付费。我们持续更新海量内容，确保瓜友能随时随地吃到最新鲜的瓜。',
  },
  {
    q: '内容多久更新一次？',
    a: '我们的编辑团队7×24小时追踪全网热点，实时更新吃瓜内容。热门事件发生后，通常在1小时内就会有相关视频合集上线，确保你不错过任何一个精彩瞬间。',
  },
  {
    q: '如何下载51吃瓜APP？',
    a: '你可以在本页的"手机吃瓜"区域找到下载入口，支持iOS（App Store）和Android双平台。下载安装后开启推送通知，第一时间接收最新吃瓜动态。',
  },
  {
    q: '我可以投稿爆料吗？',
    a: '当然可以！我们非常欢迎瓜友投稿独家猛料。你可以通过邮箱（tips@51chigua.com）、微信公众号（51chigua_official）或本页投稿入口向我们提交内容，审核通过后会标注来源并发布。',
  },
  {
    q: '吃瓜大赛怎么参加？',
    a: '吃瓜大赛定期举办，你可以关注网站公告或下载APP获取最新赛事信息。参赛方式简单，只需在指定时间内完成吃瓜挑战即可，优胜者还有丰厚奖励。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            ❓ 常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            关于51今日吃瓜，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFaq(i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm md:text-base font-bold text-foreground-900 pr-2">
                  {item.q}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === i ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}